var _circle, _rect, _rect2, _rect3, _ellipse, _ellipse2, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#D91F05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.37275,
    height: 1.30347,
    transform: "matrix(0.661648 -0.749815 0.953866 0.300234 14.7343 23.0954)",
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.37274,
    height: 1.30347,
    transform: "matrix(0.921443 0.388513 0.72916 -0.684343 20.4979 17.3929)",
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.37275,
    height: 1.30347,
    transform: "matrix(0.661648 -0.749815 0.953866 0.300234 27.358 20.2131)",
    fill: "#D91F05"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2122,
    cy: 16.6678,
    rx: 1.51515,
    ry: 1.51515,
    fill: "#D91F05"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7879,
    cy: 19.6982,
    rx: 1.51515,
    ry: 1.51515,
    fill: "#D91F05"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1364,
    y: 26.2575,
    width: 3.54545,
    height: 9.60606,
    rx: 0.5,
    stroke: "#D91F05"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2273,
    y: 23.2273,
    width: 3.54545,
    height: 12.6364,
    rx: 0.5,
    stroke: "#D91F05"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3182,
    y: 20.197,
    width: 3.54545,
    height: 15.6667,
    rx: 0.5,
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilled);
export default __webpack_public_path__ + "static/media/billed.f75fb6629cb50c69e4c875dd45949846.svg";
export { ForwardRef as ReactComponent };